module.exports = __webpack_public_path__ + "static/img/bookmark.a9dce6c9.svg";